module.exports = __webpack_public_path__ + "img/轻智能壁挂式马桶.36b9e79d.webp";